import { render, staticRenderFns } from "./goToTopButton.vue?vue&type=template&id=85d6d25a&scoped=true&"
import script from "./goToTopButton.vue?vue&type=script&lang=js&"
export * from "./goToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./goToTopButton.vue?vue&type=style&index=0&id=85d6d25a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d6d25a",
  null
  
)

export default component.exports